<template>
  <div class="modal" :class="isActive">
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">
      <div class="modal-card-head">
        <p class="modal-card-title">{{ data.headerText }}</p>
        <button class="delete" @click="closeModal" aria-label="close"></button></div>
      <div class="modal-card-body">
        <div v-if="data.type === 'img'" class="image">
          <img :src="data.src" :alt="data.headerText">
        </div>
        <figure v-else-if="data.type === 'video'">
          <video ref="modalVideo" controls autoplay>
            <source :src="data.src" type="video/mp4">
          </video>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {}
  },
  watch: {
    // Watch is needed because data.src is not updated before the video starts playing
    // a reload is needed when data.src has changed
    data: function (newdata, olddata) {
      var elVideo = this.$refs.modalVideo
      if (elVideo) {
        if (newdata !== olddata) {
          elVideo.load()
        }
      }
    }
  },
  computed: {
    isActive () {
      return this.$store.state.modalActive ? 'is-active' : ''
    }
  },
  methods: {
    closeModal () {
      this.$store.state.modalActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-card {
    width: auto;
    max-width: 90vw;

    &-body {
      display: flex;

      .image img {
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
      }

      figure {
        display: flex;
      }
    }

    @media screen and (max-width: 1023px){
      width: 100%;
      margin: 0;

      &-head {
        padding: .5rem 1rem;
      }

      &-body {
        padding: 0;
      }
    }

  }
</style>
